import Gender from './gender.vue'

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.gender = function () {
        // if (!vueInstance) {
            let el = document.createElement('div')
            document.querySelector('body').appendChild(el)

            let vueClass = Vue.extend(Gender);

            vueInstance = new vueClass({
                el: el,
                router: opt.router
            })
        // }

        vueInstance.wrapshow = true
        return vueInstance.showPicker(...arguments)
    }
}


export default Plugin;




